const rawBase = (import.meta.env.VITE_API_BASE || '').trim()
const normalizedBase = rawBase.replace(/\/$/, '')

export const apiBaseUrl = normalizedBase

export function resolveApiUrl(path: string): string {
  if (!path) {
    return normalizedBase || '/' 
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`

  if (!normalizedBase) {
    return normalizedPath
  }

  return `${normalizedBase}${normalizedPath}`
}
